import { Route, Switch } from 'react-router-dom';
import { useEffect } from 'react';
import { fetchExpenses } from '~/services/campaign';
import Disbursements from './Disbursements';

export const DisbursementsIndex = () => {
 
  return (
    <Switch>
      <Route path='/disbursements' component={Disbursements} />
    </Switch>
  );
};
